/** @format */

import "../styles/style.css";
import * as React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { config } from "@fortawesome/fontawesome-svg-core";
import "@fortawesome/fontawesome-svg-core/styles.css";
import { ConfigProvider } from "antd";
import THEME from "../common/theme";
import "../styles/index.css";
config.autoAddCss = false;
import { getCookie, setCookie } from "cookies-next";
import { SheetsRegistry, JssProvider, createGenerateId } from "react-jss";
import { GoogleOAuthProvider } from "@react-oauth/google";
import Script from "next/script";
import ContextProvider from "../context/provider";
import BreadCrumbSchema from "../components/BreadCrumbSchema";
import { COUNTRY_VARIABLES } from "@/constant/constantVar";
import App from "next/app";
import { App as AntdApp } from 'antd';
import { useEffect } from "react";
import { Provider, useDispatch } from "react-redux";
import { store } from "@/store";
import { GetEmployerRole } from "./api/Employer/Employer";
import { setEmployerRoles } from "@/store/employerSlice";
import { usePathname } from "next/navigation";
import { useRouter } from "next/router";
import { captureTrafficSource } from "../common/trafficSource";


function MyApp(props) {
  const { Component, pageProps, hostname } = props;
  const registry = new SheetsRegistry();
  const generateId = createGenerateId();
  const pathName = usePathname();
  const isEmmployer = pathName.includes("/employer/");
  const router = useRouter();
  useEffect(() => {
    if (!router.isReady || typeof window === "undefined") return;
    captureTrafficSource(window.location.search, document.referrer);
  }, [router.isReady, router.asPath]);

  useEffect(() => {
    const AccessToken = getCookie("HireSide_Employers_AccessToken");
    if (isEmmployer && (AccessToken === "" || AccessToken === null || AccessToken === undefined || AccessToken === "undefined") && pathName !== "/employer/forgotpassword") {
      router.push("/employer");
    }
  } ,[ pathName ]);
  useEffect(() => {
    const fetchRoles = async () => {
      try {
        if (isEmmployer) {
          const res = await GetEmployerRole();
          const role = Number(res?.Data?.Role);
          store.dispatch(setEmployerRoles(role));
        }
      } catch (e) {
        console.error("Failed to fetch employer role:", e);
      }
    };

    fetchRoles();

  }, [pathName]);

  if (typeof hostname === "string") {
    const parts = hostname.split(".");
    if (process.env.NEXT_PUBLIC_SERVER == "Local") {
      setCookie("countryCode", "dev", {  maxAge: 60 * 60 * 24 * 7 });
      setCookie("HireSide_CountryCode","dev",{maxAge: 30 * 24 * 60 * 60 * 1000,});
      COUNTRY_VARIABLES.countryCode = "dev";
    } else {
      if (parts.length > 2) {

        if(parts[0] == "talent") {
          parts[0] = "tcs";
        }

        setCookie("countryCode", parts[0] ?? "global", {  maxAge: 60 * 60 * 24 * 7 });
        setCookie("HireSide_CountryCode", parts[0] ?? "global",{maxAge: 30 * 24 * 60 * 60 * 1000,});
        COUNTRY_VARIABLES.countryCode = parts[0] ?? "global";
      } else {
        setCookie("countryCode", "global", {  maxAge: 60 * 60 * 24 * 7 });
         setCookie("HireSide_CountryCode","global",{maxAge: 30 * 24 * 60 * 60 * 1000,});
        COUNTRY_VARIABLES.countryCode = "global";
      }
    }
  }


  return (
    <Provider store={store}>
      <AntdApp>
        <GoogleOAuthProvider clientId="811187267962-6o4j0c4md32jphiohhj1rbqh4lokq7j2.apps.googleusercontent.com">
          <JssProvider registry={registry} generateId={generateId}>
            <ConfigProvider theme={THEME}>
              <ContextProvider>
                <Component {...pageProps} />
              </ContextProvider>
            </ConfigProvider>
          </JssProvider>
          <BreadCrumbSchema />
        </GoogleOAuthProvider>
      </AntdApp>
    </Provider>
  );
}

MyApp.getInitialProps = async (appContext) => {
  const appProps = await App.getInitialProps(appContext);
  let hostname = "";
  if (appContext.ctx.req) {
    hostname = appContext.ctx.req.headers.host;
  } else {
    hostname = window.location.hostname;
  }
  return { ...appProps, hostname };
};
export default MyApp;
